import styled from 'styled-components';

export const TermAndPolicyMenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
`;
